export default {
    select_button: 'Select',
    one_day_back: 'One day back',
    one_day_forward: 'One day forward',
    departure: 'Departure',
    arrival: 'Arrival',
    duration: 'Duration',
    transfers: 'Transfers',
    status: 'Status',
    price: 'Price',
    select: 'Select a departure',
    read_and_agree: 'Read and agree',
    status_cancelled: 'The booking time for this departure has passed, contact the boat if there is still space available and arrival.',
    status_time_passed: 'The booking time for this departure has passed. Tickets can be purchased on board if space is available. Contact',
    by_phone: 'by phone',
    status_no_capacity: 'There is no free space on the required distance. Try with a smaller number of travellers / vehicle or select another departure.',
    status_available: 'There is free space on the required distance at the time of search, and you can buy / reserve a ticket to this departure by selecting it.',
    //status_on_board: 'The booking time for this departure has passed. There was still space available, contact the boat if there is still space available and arrival.',
    norwegian_krone: 'NOK',
    no_result: 'There are no more departures today, or there are no departures on selected date.'
}
